
import React, { useState, useEffect } from "react";
import { get } from "lodash";
import axios from "../../axios";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import { useNavigate } from "react-router-dom";
import moment from "moment";
// import './CommissionSettings.css';
import Cookies from "js-cookie";
import Select from "react-select";
import * as Yup from 'yup';
import { toast } from "react-toastify";
import { bottom } from "@popperjs/core";
import Input from "../../components/Input";
import { Modal } from "../../components/Modal";
import Overlay from "../../components/Overlay";
import InputLogin from "../../components/InputLogin";
import { Field, Form, Formik, ErrorMessage } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import { extractDate, uploadImage, subadminAccessChange } from "../../utils/functions";

// Mui & material UI
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import SearchBar from "material-ui-search-bar";
import FormGroup from "@mui/material/FormGroup";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Paper } from "@material-ui/core";
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';



// icons
import { SlClose } from "react-icons/sl";
import { IoIosLogOut } from "react-icons/io";
import { TiInfoOutline } from "react-icons/ti";
import { GrApple, GrAndroid } from "react-icons/gr";
import { BsDot, BsEyeFill, BsJustify, BsPlus, BsThreeDotsVertical } from "react-icons/bs";
import { MdBlock, MdClose, MdEmail, MdLocalPhone, MdPhone } from "react-icons/md";
import { FaFilter, FaGlobe, FaPhone, FaUser, FaUserAlt, FaArrowLeft } from "react-icons/fa";
import { IoArchive, IoArrowBackCircleOutline, IoArrowForwardCircleOutline } from "react-icons/io5";

// Elements
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  Button,
  CancelButton,
  ProfileDetailForm,
} from "./CMSElement";
import { RiFontSize } from "react-icons/ri";

const useStyles = makeStyles((theme) => ({
  paperTableHeight: {
    width: "97%",
    marginLeft: "1rem",
    // minHeight: "87vh",
    border: "1px solid rgba(12, 45, 6, 0.10)",
    borderRadius: "10px",
  },
  formStyle: {
    width: "100%",
    padding: "2rem",
    overflow: "scroll",
  },
  formStyleOnly: {
    width: "100%",
  },
}));

const ContactUs = ({ setUsers, userData }) => {
  const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

  const userManagementPermissions = adminData?.adminpermissions?.modules?.find(
    (module) => module.moduleName === "CMS Management"
  )?.permissions || {};

  const canView = !!userManagementPermissions.view;
  const canAdd = !!userManagementPermissions.add;
  const canEdit = !!userManagementPermissions.edit;
  const canDelete = !!userManagementPermissions.delete;
  const canBlockUnblock = !!userManagementPermissions.blockUnblock;

  const isDisabled = !canEdit && adminData?.userType === "subAdmin";


  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [contactData, setContactData] = useState({});

  // Get user data
  useEffect(() => {
    getContactData();
  }, []);

  const getContactData = async () => {
    setIsLoading(true);

    try {
      const { data } = await axios.get(`/private/listWebPages?userType=user&pageName=contact-us`);

      setContactData(data?.data);
    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("error", error?.response)
      }
    } finally {
      setIsLoading(false);
    }
  };





  const updateCommissionSettingsData = async (values) => {
    setIsLoading(true);

    const formattedValues = {
      email: values.email,
      phoneNumber: values.phoneNumber,
      countryCode: values.countryCode,
      address: values.address,
      userType: "user",

    };

    try {
      const { data } = await axios.put(`/private/updateWebPage/${contactData?._id}`, formattedValues);

      toast.success(`${data?.message}`, { position: "top-right" });
      getContactData();

    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      }
      else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else if (error?.response?.status === 422) {
        toast.error(`${error.response.data?.errors[0]?.msg}`, {
          position: "top-right",
        });
      } else {
        console.log("error", error?.response)
      }
    } finally {
      setIsLoading(false);
    }
  };




  const validationSchema = Yup.object({
    email: Yup.string()
      .required('Email is required')
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        'Invalid Email address')
  });



  return (
    <>
      <DashboardContainer>
        <DashboardWrapper >
          <ProfileDetailForm>
            <div className="common-heading">Contact Us</div>

            <DashboardHeading>
              {/* <div className="common-heading-name">Admin Commission</div> */}

              <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{
                  email: contactData?.email || "",
                  phoneNumber: contactData?.phoneNumber || "",
                  countryCode: contactData?.countryCode || "",
                  address: contactData?.address || "",
                }}
                validate={(values) => {
                  const errors = {};

                  if (!values.email) {
                    // errors.email = "Email is required";
                  }

                  if (!values.address) {
                    errors.address = "Address is required";
                  }

                  if (!values.phoneNumber) {
                    errors.phoneNumber = "Phone number is required";
                  }

                  if (!values.countryCode) {
                    errors.countryCode = "Country code is required";
                  }

                  return errors;
                }}
                onSubmit={(values) => {
                  updateCommissionSettingsData(values);
                }}
              >
                {(formikBag) => {
                  const { values, setFieldValue, touched, errors } = formikBag;
                  return (
                    <Form className={classes.formStyleOnly}>
                      <div className="fare-section">
                        <div className="fare-container">
                          <div className="common-information">Contact Information</div>

                          <div className="row col-md-12">
                            <div className="col-md-3" style={{ display: "flex", gap: "2rem" }}>
                              {/* Email */}
                              <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
                                <label className="fare-label-name-data">Email At</label>
                                <Field name="email">
                                  {({ field }) => (
                                    <Input
                                      style={{ marginTop: "0.6rem" }}
                                      {...field}
                                      type="email"
                                      disabled={isDisabled}
                                      onChange={(e) => {
                                        if (!isDisabled) setFieldValue("email", e.target.value);
                                      }}
                                      className="form_data"
                                      placeholder="Enter your work email"
                                    // error={touched.email && errors.email ? errors.email : null}
                                    />
                                  )}
                                </Field>
                                <ErrorMessage name="email" component="p" className="error mb-0" />
                              </div>

                              {/* Phone Number */}
                              <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
                                <label className="fare-label-name-data">Phone Number</label>
                                <Field name="phoneNumber">
                                  {() => (
                                    <div className="py-2">
                                      <PhoneInput
                                        style={{
                                          border: "1px solid #26344E26",
                                          height: "3rem",
                                          width: "16rem",
                                          display: "flex",
                                          alignItems: "center",
                                          borderRadius: "4px"
                                        }}
                                        disabled={isDisabled}
                                        country={"us"}
                                        value={values.phoneNumber}
                                        onChange={(phone, country) => {
                                          setFieldValue("phoneNumber", phone);
                                          setFieldValue("countryCode", country?.dialCode || "");
                                        }}
                                        inputStyle={{
                                          background: values.phoneNumber ? "#FFFFFF80" : "#FFFFFF",
                                        }}
                                        isValid={(value) => {
                                          const length = value.replace(/\D/g, "").length;
                                          return length >= 6 && length <= 18;
                                        }}
                                        placeholder="Enter phone number"
                                      />
                                      <ErrorMessage name="phoneNumber" component="p" className="error mb-0" />
                                    </div>
                                  )}
                                </Field>
                              </div>
                            </div>
                          </div>

                          {/* Address */}
                          <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
                            <label className="fare-label-name-data">Address</label>
                            <Field name="address">
                              {({ field }) => (
                                <Input
                                  {...field}
                                  type="text"
                                  disabled={isDisabled}
                                  onChange={(e) => {
                                    if (!isDisabled) setFieldValue("address", e.target.value);
                                  }}
                                  style={{ width: "100%" }}
                                  className="form_data"
                                  placeholder="Enter your office address"
                                // error={touched.address && errors.address ? errors.address : null}
                                />
                              )}
                            </Field>
                            <ErrorMessage name="address" component="p" className="error mb-0" />
                          </div>

                          {/* Buttons */}
                          <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginTop: "1rem" }}>
                            {!(!canEdit && adminData?.userType === "subAdmin") && (
                              <>
                                <Button type="submit" disabled={isLoading} style={{ background: "#5088FB" }}>
                                  {isLoading ? "Saving..." : "Save"}
                                </Button>
                                <CancelButton type="button" onClick={() => formikBag.resetForm()}>
                                  Cancel
                                </CancelButton>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>

            </DashboardHeading>
          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer>

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactUs);

